export const MDR_SHOW_DEMO_KEY = 'mdrShowDemo'

export const getShowDemoFromStorage = (): Record<string, boolean> => {
    try {
        const raw = localStorage.getItem(MDR_SHOW_DEMO_KEY)
        if (raw) {
            const parsed = JSON.parse(raw)
            if (typeof parsed === 'object' && parsed !== null) {
                return parsed as Record<string, boolean>
            }
        }
    } catch {}
    return {}
}

export const clearMdrLocalStorage = (): void => {
    localStorage.removeItem(MDR_SHOW_DEMO_KEY)
}

export const filterByTimeRange = (items: any[], timeRange: { id: string }) => {
    if (!items || timeRange.id === 'all') return items
    const days = parseInt(timeRange.id)
    if (!days) return items
    const cutoff = new Date()
    cutoff.setDate(cutoff.getDate() - days)
    return items.filter((item) => {
        const createdAt = new Date(item.createdAt)
        return createdAt >= cutoff
    })
}
